const STYLES = {
  "Signed up": "stage-signed",
  Waitlist: "stage-waitlist",
  Registered: "stage-registered",
  "Paid in full": "stage-paid",
  Withdrawn: "stage-withdrawn",
};

export const STAGES = ["Signed up", "Waitlist", "Registered", "Paid in full", "Withdrawn"];
export const STAGE_ORDER = { "Signed up": 1, Waitlist: 2, Registered: 3, "Paid in full": 4 };

export const StageBadge = ({ stage, className = "" }) => (
  <span className={`stage-badge ${STYLES[stage] || "stage-signed"} ${className}`} data-testid="stage-badge">
    {stage || "Signed up"}
  </span>
);
